import { Component } from "@angular/core"
import { AlertController, ViewController, LoadingController, NavParams } from "ionic-angular"

import firebase from "firebase"

@Component({
  selector: "profile-data-page",
  templateUrl: "data.html",
})
export class ProfileDataPage {

  user: any = {}

  constructor(
    private alertCtrl: AlertController,
    private viewCtrl: ViewController,
    private loadingCtrl: LoadingController,
    private navParams: NavParams
  ) {

    this.user = this.navParams.get("user")
  }

  onCancel() {

    this.viewCtrl.dismiss()
  }

  onUpdate() {

    if (!this.validData())
      return

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.present()

    firebase.database().ref(`users/${this.user.uid}`).set(this.user)
      .then(() => {

        loading.dismiss()
        this.viewCtrl.dismiss(this.user)
      })
      .catch((error) => {

        console.log(error)

        loading.dismiss()

        this.alertCtrl.create({
          title: "Falha ao atualizar seus dados",
          message: "Por favor tente novamente em alguns minutos",
          buttons: ["Ok"]
        }).present()
      })
  }

  validData() {

    let message = ""
    let isOk = true

    if (!this.user.firstName || !this.user.lastName) {
      message = "Por favor informe seu nome e sobrenome"
    } else if (!this.user.occupation || !this.user.ddd || !this.user.phone) {
      message = "Por favor informe seus dados profissionais"
    }

    if (message) {
      isOk = false
      this.alertCtrl.create({
        message,
        buttons: ["Ok"]
      }).present()
    }

    return isOk
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/data.ts